
(() => {
  const init = (root) => {
    if (root.dataset.arrowsInitialized) return;
    root.dataset.arrowsInitialized = 'true';
    const form = root.querySelector('.sc-form');
    const select = root.querySelector('[data-variant]');
    const quantity = root.querySelector('[name="quantity"]');
    const add = root.querySelector('[data-add]');
    const sticky = root.querySelector('[data-sticky]');
    const stickyAdd = root.querySelector('[data-sticky-add]');
    const showImage = (id) => {
      if (!id || !root.querySelector(`[data-image-id="${id}"]`)) return;
      root.querySelectorAll('[data-image-id]').forEach(el => el.classList.toggle('is-active', el.dataset.imageId === id));
      root.querySelectorAll('[data-thumbnail]').forEach(el => {
        const active = el.dataset.thumbnail === id;
        el.classList.toggle('is-active', active);
        if (active) {
          el.setAttribute('aria-current','true');
          el.scrollIntoView({behavior:'smooth', block:'nearest', inline:'center'});
        } else {
          el.removeAttribute('aria-current');
        }
      });
    };
    root.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => {
      const slides = Array.from(root.querySelectorAll('[data-image-id]'));
      if (!slides.length) return;
      const current = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
      const next = (current + Number(button.dataset.galleryStep) + slides.length) % slides.length;
      showImage(slides[next].dataset.imageId);
    }));
    root.querySelectorAll('[data-thumbnail]').forEach(el => el.addEventListener('click', event => { event.preventDefault(); showImage(el.dataset.thumbnail); }));
    const thumbTrack = root.querySelector('[data-thumb-track]');
    root.querySelectorAll('[data-thumb-scroll]').forEach(button => button.addEventListener('click', () => {
      if (!thumbTrack) return;
      const firstThumb = thumbTrack.querySelector('[data-thumbnail]');
      const styles = getComputedStyle(thumbTrack);
      const gap = parseFloat(styles.gap) || 0;
      const cardWidth = firstThumb ? firstThumb.getBoundingClientRect().width : thumbTrack.clientWidth / 3;
      const direction = Number(button.dataset.thumbScroll) || 0;
      thumbTrack.scrollBy({left: direction * (cardWidth + gap) * 3, behavior:'smooth'});
    }));
    root.querySelectorAll('[data-quantity-change]').forEach(button => button.addEventListener('click', () => {
      if (!quantity) return;
      const min = Number(quantity.min) || 1;
      const step = Number(quantity.step) || 1;
      const max = quantity.max ? Number(quantity.max) : Infinity;
      const current = Number(quantity.value) || min;
      quantity.value = Math.max(min, Math.min(max, current + Number(button.dataset.quantityChange) * step));
      quantity.dispatchEvent(new Event('change', {bubbles:true}));
    }));
    const update = () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      const available = option.dataset.available === 'true';
      const label = available ? root.dataset.addLabel : root.dataset.soldLabel;
      const priceNode = root.querySelector('[data-price]');
      if (priceNode) priceNode.textContent = option.dataset.price;
      const compare = root.querySelector('[data-compare]');
      if (compare) {
        compare.textContent = option.dataset.compare;
        compare.hidden = option.dataset.onSale !== 'true';
      }
      root.querySelector('[data-add-text]').textContent = label;
      add.disabled = !available;
      if (stickyAdd) {
        stickyAdd.disabled = !available;
        root.querySelector('[data-sticky-price]').textContent = option.dataset.price;
        root.querySelector('[data-sticky-text]').textContent = label;
      }
      if (quantity) {
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
        const min = Number(quantity.min), step = Number(quantity.step);
        const max = quantity.max ? Number(quantity.max) : Infinity;
        const wanted = Math.max(min, Number(quantity.value) || min);
        quantity.value = Math.min(max, min + Math.ceil((wanted - min) / step) * step);
      }
      const variantPhoto = root.querySelector(`[data-product-image-id="${option.dataset.image}"]`);
      if (variantPhoto) showImage(variantPhoto.dataset.imageId);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
      root.querySelector('[data-status]').textContent = `${option.textContent.trim()}. ${label}`;
    };
    select.addEventListener('change', update);
    if (stickyAdd) stickyAdd.addEventListener('click', () => form.requestSubmit(add));
    if (sticky && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      }, {threshold:0});
      observer.observe(add);
      root.scObserver = observer;
    }
    const gallery = root.querySelector('.sc-gallery');
    gallery.addEventListener('keydown', event => {
      if (!event.target.closest('[data-thumbnail]') || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      const thumbs = [...root.querySelectorAll('[data-thumbnail]')];
      let index = thumbs.indexOf(event.target.closest('[data-thumbnail]'));
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = thumbs.length - 1;
      else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + thumbs.length) % thumbs.length;
      event.preventDefault();
      thumbs[index].focus();
      showImage(thumbs[index].dataset.thumbnail);
    });
    const zoomDialog = root.querySelector('[data-zoom-dialog]');
    root.querySelector('[data-gallery-zoom]').addEventListener('click', () => {
      const current = root.querySelector('.sc-gallery-slide.is-active');
      const content = root.querySelector('[data-zoom-content]');
      content.replaceChildren();
      const image = current?.querySelector('img');
      if (image) {
        const large = image.cloneNode(true);
        large.loading = 'eager';
        large.sizes = '90vw';
        content.append(large);
      } else if (current) content.append(current.firstElementChild.cloneNode(true));
      zoomDialog.showModal();
    });
    root.querySelector('[data-zoom-close]').addEventListener('click', () => zoomDialog.close());
    zoomDialog.addEventListener('click', event => { if (event.target === zoomDialog) {
      const rect = zoomDialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) zoomDialog.close();
    }});
    root.classList.add('sc-ready');
  };
  const initialize = (target) => target.querySelectorAll('[data-swaycare]').forEach(init);
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-swaycare]').forEach(root => root.scObserver?.disconnect()));
})();
